import { queryClient, apiRequest } from "../lib/queryClient";

const accessoriesKey = "accessories";

export function useAccessories(options = {}) {
  const {
    filters = {},
    sort = { field: "created_at", direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchAccessories    = async (pageId) => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    }
    const response = await apiRequest(
      `/admin/accessories/?${queryParams.toString()}`,
      {
        method: "GET",
      }
    );
    return response;
  };

  const createAccessories = async (pageData) => {
    const response = await apiRequest("/admin/accessories", {
      method: "POST",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [accessoriesKey] });
    return response;
  };

  const updateAccessories = async (id, pageData) => {
    const response = await apiRequest(`/admin/accessories/${id}`, {
      method: "PUT",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [accessoriesKey] });
    return response;
  };

  const deleteAccessories = async (pageId) => {
    await apiRequest(`/admin/accessories/${pageId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [accessoriesKey] });
    return pageId;
  };

  const toggleAccessoriesStatus = async (id) => {
        const response = await apiRequest(`/admin/accessories/${id}`, {
          method: "PATCH",
        });
        queryClient.invalidateQueries({ queryKey: [accessoriesKey] });
        return response;
      };

  return {
    fetchAccessories,
    createAccessories,
    updateAccessories,
    deleteAccessories,
    toggleAccessoriesStatus
  };
}
